import { DetailedHTMLProps, FC, ForwardedRef, HTMLAttributes, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface CardBodyProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    ref?: ForwardedRef<HTMLDivElement>;
}

const CardBody = forwardRef<HTMLDivElement, CardBodyProps>((props, ref) => {
    const { children, className, ...rest } = props;

    return (
        <div ref={ref} {...rest} className={twMerge('px-6 py-6', className)}>
            {children}
        </div>
    );
});

export default CardBody;
